import { render, staticRenderFns } from "./Solicitar_QR.vue?vue&type=template&id=71fd4e69&scoped=true&"
import script from "./Solicitar_QR.vue?vue&type=script&lang=js&"
export * from "./Solicitar_QR.vue?vue&type=script&lang=js&"
import style0 from "./Solicitar_QR.vue?vue&type=style&index=0&id=71fd4e69&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fd4e69",
  null
  
)

export default component.exports